module.exports = __webpack_public_path__ + "img/143.2.ed284444.png";